import { Tooltip } from '@mui/material'
import { cities } from 'keys'
import React from 'react'

const AffiliationLabel = (props) => {
    const { name, display_name, city, showTooltip, institution_code } = props

    return (
        <Tooltip placement='left' title={showTooltip ? `${name} ${display_name ? ` (${display_name})` : ""} ${institution_code ? ` ${institution_code}` : ""}` : ""}>
            {name}
            {display_name && ` (${display_name})`}
            {city?.label && ` - ${city?.label}`}
        </Tooltip>
    )
}

export default AffiliationLabel